module.exports = __webpack_public_path__ + "static/img/6622_phase_function_Paper_Points.df7977b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6622_phase_function_Paper_Points.png
// module id = DSO3
// module chunks = 0